import { api } from '@/lib/api'
import type {
  CalculateReconciliationResponse,
  ReconcileAccount,
  ReconciliationHistoryResponse,
  SubmitReconciliationPayload,
  SubmitReconciliationResponse,
} from './types'

export const reconcileApi = {
  accounts: () => api.get<ReconcileAccount[]>('/api/reconcile/accounts'),
  history: (accountNo?: string) =>
    api.get<ReconciliationHistoryResponse>('/api/reconcile/history', {
      query: accountNo ? { account_no: accountNo } : undefined,
    }),
  calculate: (account_no: string, date: string) =>
    api.post<CalculateReconciliationResponse>('/api/reconcile/calculate', {
      account_no,
      date,
    }),
  submit: (payload: SubmitReconciliationPayload) =>
    api.post<SubmitReconciliationResponse>('/api/reconcile/submit', payload),
  // Phase 2e - customer payments inside a reconciliation window, used
  // as cross-reference candidates against bank_statement rows.
  vendorPayments: (dateFrom: string | null, dateTo: string | null) =>
    api.get<{ payments: Array<{
      id: number
      paid_at: string
      amount: string
      currency: string
      method: string
      provider: string | null
      provider_payment_id: string | null
      reference: string | null
      vendor_display_name: string
      bill_id: number | null
      bill_number: string | null
    }> }>('/api/invoicing/stats/vendor-payments', {
      query: {
        ...(dateFrom ? { date_from: dateFrom } : {}),
        ...(dateTo ? { date_to: dateTo } : {}),
      },
    }),
  customerPayments: (dateFrom: string | null, dateTo: string | null) =>
    api.get<{ payments: Array<{
      id: number
      received_at: string
      amount: string
      currency: string
      method: string
      provider: string | null
      provider_payment_id: string | null
      customer_display_name: string
      invoice_id: number | null
      invoice_number: string | null
    }> }>('/api/invoicing/stats/customer-payments', {
      query: {
        ...(dateFrom ? { date_from: dateFrom } : {}),
        ...(dateTo ? { date_to: dateTo } : {}),
      },
    }),
}
